var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidatePortalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H2 1v2h22v-1-1h-1zm0 4H2 1v2h22v-1-1h-1zM6 7H5v2h2V8 7H6zm14-6H4C3 1 2 1 2 2 1 2 1 3 1 4v8c0 1 0 2 1 2 0 1 1 1 2 1h16c1 0 2 0 2-1 1 0 1-1 1-2V4c0-1 0-2-1-2 0-1-1-1-2-1zm1 11v1H4 3V4 3h18v9zm-9-7c-1 0-1 0-2 1 0 0-1 0-1 1v2s0 1 1 1c0 1 1 1 1 1h2c1 0 1-1 1-1 1-1 1-1 1-2s0-2-1-2c0-1-1-1-2-1zm0 4h-1V8 7h2v2h-1zm6-2h-1v2h2V8 7h-1z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatePortalIcon);
export default __webpack_public_path__ + "static/media/candidatePortal-icon.295353c5c97fa45e5c0600d8f6f3cc70.svg";
export { ForwardRef as ReactComponent };